import React from "react";
import { getLanguage } from "../../utils/language";
type ChipSize = "xs" | "sm" | "md" | "lg";
interface LangChipProps {
  code: string;
  size?: ChipSize;
  tone?: "brand" | "tint" | "surface" | "accent";
}
const sizes: Record<ChipSize, string> = {
  xs: "h-5 min-w-[26px] px-1 text-[10px] rounded-md border-2",
  sm: "h-7 min-w-[34px] px-1.5 text-xs rounded-lg border-2",
  md: "h-9 min-w-[44px] px-2 text-sm rounded-xl border-3",
  lg: "h-14 min-w-[64px] px-3 text-xl rounded-card border-3"
};
const tones = {
  brand: "bg-brand text-white",
  tint: "bg-brand-tint text-ink",
  surface: "bg-surface text-ink",
  accent: "bg-accent text-night"
};
export function LangChip({
  code,
  size = "sm",
  tone = "brand"
}: LangChipProps) {
  const lang = getLanguage(code);
  return <span title={lang.name} className={`inline-flex shrink-0 items-center justify-center border-line font-bold uppercase leading-none tracking-wide ${sizes[size]} ${tones[tone]}`} data-id="element-1194" data-mp="3koid7bfpgwps">
      {code}
      <span className="sr-only" data-id="element-1195" data-mp="v9bg9ajwuif1"> ({lang.name})</span>
    </span>;
}
interface PairChipsProps {
  target: string;
  base: string;
  size?: "sm" | "md" | "lg";
}
export function PairChips({
  target,
  base,
  size = "md"
}: PairChipsProps) {
  const baseSize: ChipSize = size === "lg" ? "sm" : "xs";
  return <span className="relative inline-flex shrink-0 items-end" data-id="element-1196" data-mp="gkoouah0e07g">
      <LangChip code={target} size={size} tone="brand" data-id="element-1197" data-mp="1e7no8sz35m91" />
      <span className="-ml-2 -mb-1.5" data-id="element-1198" data-mp="1e6chqle9a0e8">
        <LangChip code={base} size={baseSize} tone="surface" data-id="element-1199" data-mp="1e5b6aftbvbvz" />
      </span>
    </span>;
}